import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation/enumHelpers';
import { ACCESS_POLICY_DEFINITION_GROUPS_EDITOR_CONFIG } from '../utils/accessPolicyDefinitionGroupsEditorConfig';

export default {
  validationMessages: {
    required: 'form.error.required',
  },
  fields: [
    {
      label: 'accessPolicy.columns.name',
      name: 'name',
      requiredEdit: true,
      rules: [{ required: true }],
    },
    {
      label: 'accessPolicy.columns.priority',
      name: 'priority',
      type: 'number',
      requiredEdit: true,
      rules: [{ required: true }],
    },
    {
      label: 'accessPolicy.columns.effect',
      name: 'effect',
      type: 'select',
      locale: true,
      options: createEnumOptions(CoreEnums.CompanyAccessPolicyEffect, 'accessPolicy.effect', {
        casing: 'lower',
      }),
      rules: [{ required: true }],
    },
    {
      label: 'accessPolicy.definition.logicalOperator',
      name: 'definitionLogicalOperator',
      itemDb: 'definition.logicalOperator',
      type: 'select',
      locale: true,
      options: createEnumOptions(CoreEnums.LogicalOperator, 'global.field', {
        casing: 'lower',
      }),
      initialValue: CoreEnums.LogicalOperator.And,
    },
    {
      label: 'accessPolicy.definition.rules',
      name: 'definitionRules',
      itemDb: 'definition.rules',
      type: 'dynamicFieldsList',
      locale: true,
      title: 'accessPolicy.definition.rules',
      showEdit: true,
      hideTableHeader: false,
      rules: [{ required: false }],
      defaultValue: [],
      fields: ACCESS_POLICY_DEFINITION_GROUPS_EDITOR_CONFIG.ruleFields,
    },
    {
      label: 'accessPolicy.definition.groups',
      name: 'definitionGroups',
      itemDb: 'definition.groups',
      type: 'definitionGroups',
      locale: true,
      rules: [{ required: false }],
      defaultValue: [],
      definitionGroupsConfig: ACCESS_POLICY_DEFINITION_GROUPS_EDITOR_CONFIG,
    },
    {
      label: 'global.enabledElement',
      name: 'isActive',
      type: 'switch',
      defaultChecked: true,
      checked: true,
      labelCol: { span: 19 },
      wrapperCol: { span: 5 },
      style: {
        paddingLeft: 16,
      },
    },
    {
      label: 'global.id',
      name: 'id',
      hidden: true,
    },
    {
      label: 'global.created',
      name: 'created',
      hidden: true,
    },
    {
      label: 'global.updated',
      name: 'updated',
      hidden: true,
    },
  ],
};
